import { Views } from '@singularsystems/neo-react';
import { AppService, Types } from '../../DomainTypes';
import LogCriteria from "../../Models/Logging/LogCriteria";
import { Data } from "@singularsystems/neo-core";
import LogLookup from "../../Models/Logging/LogLookup";

export default class LogsVM extends Views.ViewModelBase {

    constructor(
        taskRunner = AppService.get(Types.Neo.TaskRunner),
        private notifications = AppService.get(Types.Neo.UI.GlobalNotifications),
        private logApiClient = AppService.get(Types.Domain.ApiClients.Logs)) {

        super(taskRunner);
        this.makeObservable();

        this.autoDispose(this.criteria.onAnyPropertyChanged(() => this.pageManager.refreshData()));
    }

    public criteria = new LogCriteria();
    public pageManager = new Data.PageManager(this.criteria, LogLookup, this.logApiClient.getLogs, { fetchInitial: true, allowSort: false, sortBy: "timeStamp" });

    public async initialise() {

    }
}